import { HOME_HEALTH_AGENCY, SKILLED_NURSING_FACILITY } from 'constants/locationTypes';
import { useProfile } from 'context/profile';
import Client from 'models/Client';

// Reads the nested group type rather than `providedProviderTypes`, which also needs
// `enabledProviderTypes` loaded; the preferences page's clients index does not load it.
export function referralBuildingTerminology(client: Client) {
  const provided = client.clientProvidedGroupTypes.map((clientGroupType) => clientGroupType.groupType?.apiName);
  const homeHealth = provided.includes(HOME_HEALTH_AGENCY) && !provided.includes(SKILLED_NURSING_FACILITY);

  return homeHealth
    ? {
        groupType: HOME_HEALTH_AGENCY,
        label: 'Agency',
        pluralLabel: 'agencies',
        preferencesTitle: 'Specific agencies',
        chatRailHeading: 'View Chat by Agency',
      }
    : {
        groupType: SKILLED_NURSING_FACILITY,
        label: 'SNF',
        pluralLabel: 'SNFs',
        preferencesTitle: 'Specific SNFs',
        chatRailHeading: 'View Chat by SNF',
      };
}

export function useReferralBuildingTerminology() {
  const { profile } = useProfile();
  return referralBuildingTerminology(profile.actingClient);
}
